<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/03_Parchi-Riserve/03b_Sila_Lago-Arvo.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Parco Nazionale della Sila</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Sila</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Il simbolo di questo parco situato nel cuore della Calabria è il lupo, che ha ripopolato questo luogo incantevole, 
            le sue montagne e le valli. In Sila è preservato uno dei più significativi patrimoni di biodiversità italiani. 
            A piedi o in bici, si possono apprezzare scorci selvaggi e scenari che cambiano con le stagioni e con il variare delle quote, 
            si possono scoprire i grandi “patriarchi vegetali”, alberi secolari e monumentali che convivono in equilibrio con l’ambiente circostante,
             moderano il clima e valorizzano il paesaggio. Negli oltre 70.000 chilometri quadrati del Parco non mancano i Musei Tematici,
              Multimediali ed Interattivi per approfondire la conoscenza della natura e della cultura, i centri dedicati ai visitatori
              , i ristoranti, le attività agricole. Ma soprattutto, il Parco di consente di praticare tantissime attività outdoor in totale sintonia 
              con l’ambiente naturale e nel rispetto del suo equilibrio. Nel territorio del Parco ricade la Riserva della Biosfera “MaB Sila”, la decima 
              Riserva della Biosfera italiana nella Rete Mondiale dei siti di eccellenza UNESCO
        </p>
    </div>
</div>
<br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-9 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale della Sila.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img src="../../../assets/images/03_Parchi-Riserve/logo-parco-sila.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToAcri()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gli storici villaggi<br />della Sila</h1>
                        <a (click)="goToLorica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Arte e spiritualità<br />in Sila</h1>
                        <a (click)="goToArte()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>